import { render } from "./TvmSlideOutKbbTradeValue.vue?vue&type=template&id=a2bae238&scoped=true"
import script from "./TvmSlideOutKbbTradeValue.vue?vue&type=script&lang=js"
export * from "./TvmSlideOutKbbTradeValue.vue?vue&type=script&lang=js"

import "./TvmSlideOutKbbTradeValue.vue?vue&type=style&index=0&id=a2bae238&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2bae238"],['__file',"src/Components/ChatWidget/SlideOutPanel/TvmSlideOutKbbTradeValue/TvmSlideOutKbbTradeValue.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a2bae238"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a2bae238', __exports__)) {
    api.reload('a2bae238', __exports__)
  }
  
  module.hot.accept("./TvmSlideOutKbbTradeValue.vue?vue&type=template&id=a2bae238&scoped=true", () => {
    api.rerender('a2bae238', render)
  })

}


export default __exports__